import { orderedColumns } from './projectView';

const personName = (users, id) => {
  const u = users.find((x) => x.id === id);
  return u ? [u.name, u.surname].filter(Boolean).join(' ') : '';
};

/** Testo di una cella per l'esportazione (etichette al posto dei codici delle opzioni). */
export const cellText = (task, column, users, allTasks = []) => {
  if (column.type === 'title') return task.title || '';
  const raw = task.data[String(column.id)];
  switch (column.type) {
    case 'created_time': return task.created_at || '';
    case 'updated_time': return task.updated_at || '';
    case 'created_by': return personName(users, task.created_by_user_id);
    case 'updated_by': return personName(users, task.updated_by_user_id);
    default: break;
  }
  if (raw === undefined || raw === null) return '';
  switch (column.type) {
    case 'select':
    case 'status': return column.options.find((o) => o.value === raw)?.label || '';
    case 'multi_select': return (Array.isArray(raw) ? raw : []).map((v) => column.options.find((o) => o.value === v)?.label || '').filter(Boolean).join(', ');
    case 'person': return (Array.isArray(raw) ? raw : [raw]).map((id) => personName(users, id)).filter(Boolean).join(', ');
    case 'checkbox': return raw ? 'Sì' : '';
    case 'date': return raw;
    case 'daterange': return [raw.start, raw.end].filter(Boolean).join(' → ');
    case 'files': return (Array.isArray(raw) ? raw : []).map((f) => f.name).join('; ');
    case 'task_relation': return (Array.isArray(raw) ? raw : []).map((id) => allTasks.find((t) => t.id === id)?.title || '').filter(Boolean).join('; ');
    default: return String(raw);
  }
};

/** Righe per l'esportazione: intestazione + una riga per attività (colonne visibili, nell'ordine della vista). */
export const buildExportRows = (columns, config, tasks, users, allTasks, ticketsLabel) => {
  const cols = orderedColumns(columns, config);
  const rows = [[...cols.map((c) => c.name), ticketsLabel]];
  tasks.forEach((task) => {
    rows.push([...cols.map((c) => cellText(task, c, users, allTasks)), task.tickets.map((tk) => `#${tk.id}`).join(' ')]);
  });
  return rows;
};

/** Colonne importabili: quelle in cui si può scrivere (non calcolate né file). */
export const importableColumns = (columns) => columns.filter((c) => !['files', 'created_time', 'updated_time', 'created_by', 'updated_by'].includes(c.type));

/** Abbina le intestazioni del file alle colonne per nome; "" = ignora, "title" = nome dell'attività. */
export const autoMap = (headers, columns) => {
  const usable = importableColumns(columns);
  const used = new Set();
  const mapping = headers.map((header) => {
    const name = header.trim().toLowerCase();
    const hit = usable.find((c) => !used.has(c.id) && c.name.trim().toLowerCase() === name);
    if (!hit) return '';
    used.add(hit.id);
    return hit.type === 'title' ? 'title' : `col:${hit.id}`;
  });
  // Nessuna intestazione abbinata al nome: la prima colonna del file diventa il nome dell'attività.
  if (!mapping.includes('title') && mapping.length > 0 && mapping[0] === '') mapping[0] = 'title';
  return mapping;
};
